import React, { useEffect, useState } from "react";
import { IoDocumentText } from "react-icons/io5";
import { FaDatabase } from "react-icons/fa";
import { MdEditDocument } from "react-icons/md";
import * as FiIcons from "react-icons/fi";
import * as HiIcons from "react-icons/hi";
import * as FaIcons from "react-icons/fa";
import * as IoIcons from "react-icons/io5";

// ── Utility: resolve icon by name ──────────────────────────────────────────────
export const getIcon = (iconName) => {
    if (!iconName) return null;
    const name = iconName.trim();
    return FiIcons[name] || HiIcons[name] || FaIcons[name] || IoIcons[name] || null;
};

// ── Collapsible Parent Section ─────────────────────────────────────────────────
export function ParentSection({ parent, kids, activeMenu, onSelect, sidebarOpen }) {
    const [open, setOpen] = useState(false);
    const hasActiveChild = kids.some((k) => k.service_name === activeMenu);
    const ParentIcon = getIcon(parent.icon) || IoDocumentText;

    useEffect(() => {
        if (hasActiveChild) setOpen(true);
    }, [hasActiveChild]);

    return (
        <li className="parent-menu">
            <div
                className={`parent-title ${hasActiveChild ? "parent-has-active" : ""}`}
                role="button"
                tabIndex={0}
                onClick={() => setOpen(!open)}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        setOpen(!open);
                    }
                }}
            >
                <div className="parent-icon">
                    {sidebarOpen && (
                        <>
                            <ParentIcon size={16} className="me-2" />
                            <span>{parent.service_name}</span>
                        </>
                    )}
                </div>

                {!sidebarOpen && (
                    <span title={parent.service_name}>
                        <ParentIcon size={16} />
                    </span>
                )}

                {sidebarOpen && (
                    <span className="parent-arrow">{open ? "▾" : "▸"}</span>
                )}
            </div>

            {open && (
                <div className="children-wrapper">
                    {kids.map((child) => {
                        const ChildIcon = getIcon(child.icon) || FaDatabase;
                        const childPath = child.target || child.service_name;
                        return (
                            <div
                                key={child.service_id}
                                className={`child-item ${activeMenu === child.service_name ? "active" : ""}`}
                                role="button"
                                tabIndex={0}
                                onClick={() => onSelect(childPath)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault();
                                        onSelect(childPath);
                                    }
                                }}
                            >
                                <ChildIcon size={16} className="me-2" />
                                <span className="child-itemnew">{child.service_name}</span>
                            </div>
                        );
                    })}
                </div>
            )}
        </li>
    );
}

// ── Unified MenuItem: dropdown if has kids, else direct route ──────────────────
export function MenuItem({ item, kids, activeMenu, onSelect, sidebarOpen, defaultIcon }) {
    const ItemIcon = getIcon(item.icon) || defaultIcon || MdEditDocument;

    if (kids && kids.length > 0) {
        return (
            <ParentSection
                parent={item}
                kids={kids}
                activeMenu={activeMenu}
                onSelect={onSelect}
                sidebarOpen={sidebarOpen}
            />
        );
    }

    return (
        <li
            className={`single-menu ${activeMenu === item.service_name ? "active" : ""}`}
            role="button"
            tabIndex={0}
            onClick={() => onSelect(item.target)}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onSelect(item.item.target);
                }
            }}
        >
            <ItemIcon size={16} className="me-2" />
            {sidebarOpen && <span>{item.service_name}</span>}
        </li>
    );
}
export const showValue = (value) => value ? value : "-";
